import { render, staticRenderFns } from "./ImmobiliPatrimonioTable.vue?vue&type=template&id=a5f0169c&"
import script from "./ImmobiliPatrimonioTable.vue?vue&type=script&lang=js&"
export * from "./ImmobiliPatrimonioTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImmobiliPatrimonioTable.vue"
export default component.exports